import { useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { SocialWebChannelsWidget } from 'schemas/SocialWebChannelsWidgetSchema'
import ChannelComparisonBinaryDisplayOption from 'enums/ChannelComparisonBinaryDisplayOption'

// eslint-disable-next-line import/prefer-default-export
export const useDisplayOptions = ({ widgetId }: { widgetId: number }) => {
  const { selectedDisplayOptions } = useDashboardWidgetSetting<SocialWebChannelsWidget>(widgetId)

  return {
    isByNetworkType: selectedDisplayOptions?.includes(
      ChannelComparisonBinaryDisplayOption.BY_NETWORK_TYPE
    ),
    hasPercentShare: selectedDisplayOptions?.includes(
      ChannelComparisonBinaryDisplayOption.PERCENT_SHARE
    ),
    hasAggregateRows: selectedDisplayOptions?.includes(
      ChannelComparisonBinaryDisplayOption.AGGREGATE_ROWS
    ),
    shouldHideChannelsWithZeroBrandPosts: selectedDisplayOptions?.includes(
      ChannelComparisonBinaryDisplayOption.HIDE_WITH_ZERO_BRAND_POSTS
    )
  }
}
